import _axios from "../../libs/axios";

export default (context) => {
  const dayFields = [
    { key: "hrsMO", label: "Lunes" },
    { key: "hrsTU", label: "Martes" },
    { key: "hrsWE", label: "Miércoles" },
    { key: "hrsTH", label: "Jueves" },
    { key: "hrsFR", label: "Viernes" },
    { key: "hrsSA", label: "Sábado" },
    { key: "hrsSU", label: "Domingo" }
  ];

  const buildClassDaysText = (data) => {
    const classDays = dayFields
      .filter((d) => !!data?.[d.key])
      .map((d) => `${d.label} ${data[d.key]}`);

    return classDays.length > 0 ? classDays.join(", ") : "Sin clases programadas";
  };

  let roles = [];

  _axios.get('admGroup/getTypes')
  .then(r => {
      roles = r.data.Results     
  });


    return {
      config: {
        hiddenTitle: true,
        pageSize: 40,
        customPathPost: "admActivityParts/update/{ID}",
        remapRow: (d) => {
          d.master = d.masterId.label
          return d
        }
      },
  
      actions: {
        create: false,
        edit: true,
        delete: true
      },

      form: {
        remapOne: (r) => {
          if (r.status >= 0) {
            r.data.masterId = { value: r.data.masterId, label: r.data.masterName }
            r.data.classDaysInfo = buildClassDaysText(r.data);
            r.data.classDurationInfo = r.data.duration ? `${r.data.duration} min` : "No definida";
            r.data.classLocationInfo = r.data.location || "No definida";
          }
          return r
        },
        setValuesBeforePost: (values) => {
          values.masterId = values.masterId.value
          delete values.classDaysInfo
          delete values.classDurationInfo
          delete values.classLocationInfo
          return values
        },
        fields: [
          {
            col: 12,
            name: "name",
            value: "",
            type: "text",
            label: "Sección",
            rules: 'required',
            disabled: true,
            opts: {
              style: 'float-label',
            }
          },
          {
            col: 12,
            name: "masterId",
            value: "",
            type: "select",
            label: "Profesor principal",
            rules: 'required',
            opts: {
              style: 'float-label',
              path: "/admStaff/get?pick=true",
              setOutput: (v) => v
            }
          },
          {
            col: 12,
            name: "classDaysInfo",
            value: "",
            type: "text",
            label: "Días con clase",
            disabled: true,
            opts: {
              style: "float-label"
            }
          },
          {
            col: 6,
            name: "classDurationInfo",
            value: "",
            type: "text",
            label: "Duración",
            disabled: true,
            opts: {
              style: "float-label"
            }
          },
          {
            col: 6,
            name: "classLocationInfo",
            value: "",
            type: "text",
            label: "Ubicación",
            disabled: true,
            opts: {
              style: "float-label"
            }
          },
          {
            col: 12,
            name: "ID",
            value: ""
          }
        ],
        detailGrid: () => {
          return context.state.idItemSelected ?
          {
            module: 'admActivityMasters',
            parentIdField: 'ID',
            embeded: (c) => {
              return {
                config: {
                  pageSize: 40,
                  remap: (list,row) => { list.data.Results = list.data.Results.map(row); return list },
                  remapRow: (r) => { 
                    let rol = roles.find(f => f.ID === r.alterType)
                    if (rol) r.alterTypeName = rol.name
                    return r
                  }
                },
            
                actions: {
                  create: {
                    reloadGrid: true
                  },
                  edit: {
                    reloadGrid: true
                  },
                  delete: true,
                  print: false,
                  export: false
                },
            
                filter: {
                  fields: []
                },
            
                form: {
                  remapOne: (r) => {
                    if (r.status >= 0) {
                      r.data.userId = { value: r.data.userId, label: r.data.userName }
                      r.data.alterType = { value: r.data.alterType, label: roles.find(f => f.ID === r.data.alterType)?.name || '-' }
                    }
                    return r
                  },
                  fields: [
                    {
                      col: 12,
                      name: "userId",
                      value: "",
                      type: "select",
                      label: "Maestro / instructor",
                      rules: 'required',
                      opts: {
                        style: 'float-label',
                        path: "/admStaff/get?pick=true"
                      }
                    },
                    {
                      col: 12,
                      name: "role",
                      value: null,
                      type: "text",
                      label: "Rol en curso/sección",
                      rules: 'required',
                      opts: {
                        style: 'float-label'
                      }
                    },
                    {
                      name: "alterType",
                      value: "",
                      col: 12,
                      type: "select",
                      label: "Tipo de rol",
                      rules: 'required',
                      opts: {
                        style: 'float-label',
                        isMulti: false,
                        tooltip: true,
                        path: "/admGroup/getTypes?pick=true"
                      }
                    }
                  ]      
                },
            
                columns: [
                  {
                    Header: "ID",
                    accessor: "ID",
                    maxWidth: 40
                  },
                  {
                    Header: "Nombres",
                    accessor: "name"
                  },
                  {
                    Header: "Rol en curso/sección",
                    accessor: "alterTypeName"
                  }
                ]
              }
            }
          } : null
        }
      },  
  
      columns: [
        {
          Header: "Sección",
          accessor: "section"
        },
        {
          Header: "Profesor principal",
          accessor: "master"
        }
      ]
    }
  }